import { render, staticRenderFns } from "./slot-sorting.vue?vue&type=template&id=38338d45"
import script from "./slot-sorting.vue?vue&type=script&lang=js"
export * from "./slot-sorting.vue?vue&type=script&lang=js"
import style0 from "./slot-sorting.vue?vue&type=style&index=0&id=38338d45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports